import React, {useEffect, useRef, useState} from 'react';
import {Link, Navigate, Route, Routes, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import { Helmet } from "react-helmet";

import {Collapse} from "antd";
import {RightOutlined} from '@ant-design/icons'
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";
import TalentPortal from "../talent-portal/TalentPortal";
import {useOpportunity} from "../../providers/OpportunityProvider";

import MatchedTalentPanel from './components/MatchedTalentPanel';
import CollapseRolesHeader from './components/CollapseRolesHeader';
import OppReviewBrief from "./components/OppReviewBrief";
import {useMount} from "react-use";
import {useAuth} from "../../providers/AuthProvider";
import {OppSignedContract} from "./components/OppSignedContract";
import SupplierManageTeamScopeLayout from "./components/SupplierManageTeamScopeLayout";
import CollapseTeamsHeader from "./components/CollapseTeamsHeader";
import MatchedTeamPanel from "./components/MatchedTeamPanel";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);


const OppPositionDetails = (props) => {

    const {opportunity, isDisabled} = useOpportunity();

    if (!opportunity) return null;

    return (
        <div
            className="flex flex-col md:flex-row md:flex-wrap gap-3 sm:gap-5 items-stretch xs:items-start">
            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Position
                    </p>
                    <p>{opportunity.project_position?.title}</p>
                </div>

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Target Rate
                    </p>
                    <p>{TB.formatCurrency(opportunity.project_position?.estimated_rate)}</p>
                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Est Payout
                    </p>
                    <p>{TB.formatCurrency(opportunity.project_position?.estimated_payout, false)}</p>
                </div>
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Wripple Roles
                    </p>
                    {opportunity.project_position?.disciplines?.length > 0 ?
                        TB.map(opportunity.project_position.disciplines, discipline => (
                            <p className="font-medium text-secondary text-xs" key={discipline.name}>{discipline.name}</p>
                        )) : (
                            <p>N/A</p>
                        )}
                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Start Date
                    </p>
                    <p>{TB.moment(opportunity.project_position?.started_at)?.format('ll')}</p>
                </div>

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Brief Status
                    </p>
                    <div className="mt-1 flex flex-row gap-1.5 items-center justify-start">
                        {opportunity.status === 'Lost' ? (
                            <p className="inline text-xs rounded-full bg-danger py-1 px-3 text-white">{opportunity.display_status}</p>
                        ) : !opportunity.isAccepted() ? (
                            <p className="inline text-xs rounded-full bg-warning py-1 px-3">Review
                                Brief</p>
                        ) : (
                            <p className="inline text-xs rounded-full bg-wrippleSuccessLight py-1 px-3">Brief
                                Accepted</p>
                        )
                        }
                        {opportunity.isAvailable() && (
                            <Link to={'review-project-brief'} className="btn-link btn-link-info">
                                Review
                            </Link>
                        )}
                    </div>

                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        End Date
                    </p>
                    <p>{TB.moment(opportunity.project_position?.ended_at)?.format('ll')}</p>
                </div>
            </div>
        </div>
    )
}
const OppServiceDetails = (props) => {

    const {opportunity, isDisabled} = useOpportunity();

    if (!opportunity) return null;

    return (
        <div
            className="flex flex-col md:flex-row md:flex-wrap gap-3 sm:gap-5 items-stretch xs:items-start">
            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">

                    </p>
                    <p>Creative Site</p>
                </div>

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Target Rate
                    </p>
                    {/*<p>{TB.formatCurrency(opportunity.project_position?.estimated_rate)}</p>*/}
                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Est Payout
                    </p>
                    <p>{TB.formatCurrency(opportunity.project?.platform_cost, false)}</p>
                </div>
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Team Service
                    </p>
                    {opportunity.project?.disciplines?.length > 0 ?
                        TB.map(opportunity.project.disciplines, discipline => (
                            <p className="font-medium text-secondary text-xs" key={discipline.name}>
                                {discipline.name}
                            </p>
                        )) : (
                            <p>N/A</p>
                        )}
                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Start Date
                    </p>
                    {/*<p>{TB.moment(opportunity.project_position?.started_at)?.format('ll')}</p>*/}
                </div>

                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        Brief Status
                    </p>
                    <div className="mt-1 flex flex-row gap-1.5 items-center justify-start">
                        {opportunity.status === 'Lost' ? (
                            <p className="inline text-xs rounded-full bg-danger py-1 px-3 text-white">{opportunity.display_status}</p>
                        ) : !opportunity.isAccepted() ? (
                            <p className="inline text-xs rounded-full bg-warning py-1 px-3">
                                Review Brief
                            </p>
                        ) : (
                            <p className="inline text-xs rounded-full bg-wrippleSuccessLight py-1 px-3">
                                Brief Accepted
                            </p>
                        )}
                        {opportunity.isAvailable() && (
                            <Link to={'review-project-brief'} className="btn-link btn-link-info">
                                Review
                            </Link>
                        )}
                    </div>

                </div>
            </div>

            <div className="flex flex-col gap-3 flex-1">
                <div>
                    <p className="inline font-semibold text-xs text-light-gray4 whitespace-nowrap">
                        End Date
                    </p>
                    {/*<p>{TB.moment(opportunity.project_position?.ended_at)?.format('ll')}</p>*/}
                </div>
            </div>
        </div>
    )
}

const SupplierOppDetails = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {auth} = useAuth();
    const {
        opportunity,
        isDisabled,
        isLoading,
    } = useOpportunity();
    const rejectModal = useRef();
    const routeRef = useRef();

    const [activeRow, setActiveRow] = useState(opportunity.matching_talent?.length > 0 ? TB.find(opportunity.matching_talent, matchedOpp => matchedOpp.job_candidate?.has_confirmed_scope && matchedOpp?.job_candidate.id && !matchedOpp.is_dead)?.job_candidate?.id : null);
    const [selectedUserOpp, setSelectedUserOpp] = useState(null);


    const rejectUserOpportunity = async (userOpp) => {
        await setSelectedUserOpp(userOpp)
        await rejectModal?.current.showModal();
    }


    if (!auth) {
        return <div/>;
    }

    if (isLoading || !opportunity) {
        return null
    }

    return (
        <React.Fragment>

            <div className="bg-white w-full">
                <div className="basis-[78%] max-w-[1200px] flex-0 m-auto py-6">

                    <div className="flex justify-start mb-2">
                        <div>
                            <p>Project name</p>
                            <p className="text-xl">{opportunity.project?.name}</p>
                        </div>

                        <div className="rounded-full ml-auto bg-wrippleSuccessLight py-1 px-3 self-start">
                            Opportunity Open
                        </div>

                    </div>

                    {opportunity.is_team_opp ? <OppServiceDetails/> : (
                        opportunity.project_position && <OppPositionDetails/>
                    )}
                </div>
            </div>
            <div className="supplier-portal-container pb-6 flex-col items-stretch">
                <div className="talent-portal-page-container my-10 mx-auto">
                    <div>
                        <div>
                            <div className="bg-wrippleOffWhite p-4">
                                <h2 className="text-lg">
                                    Matched Talent {opportunity.matching_talent?.length > 0 && `(${opportunity.matching_talent?.length})`}
                                </h2>
                            </div>

                            <div className="bg-white p-4 divide-y divide-wrippleLightGrayBg">

                                {opportunity.is_for_team ? (
                                    <React.Fragment>
                                        <Collapse
                                            accordion
                                            ghost
                                            activeKey={activeRow}
                                            expandIcon={({isActive, panelKey, ...panelProps}) => {
                                                let teamOpp = TB.find(opportunity.matching_talent || [], ['job_candidate.id', parseInt(panelKey)]);
                                                if (!teamOpp || teamOpp.is_dead || !teamOpp.job_candidate?.has_confirmed_scope) {
                                                    return <div className="w-[18px] h-full"/>
                                                }

                                                return (
                                                    <RightOutlined
                                                        className="clickable pt-3"
                                                        onClick={async (e) => {
                                                            e.preventDefault()
                                                            if (String(activeRow) === String(panelKey)) {
                                                                return setActiveRow(undefined)
                                                            }
                                                            return setActiveRow(panelKey)
                                                        }}
                                                        rotate={isActive ? 90 : undefined}
                                                        style={{fontSize: 18}}
                                                    />
                                                )
                                            }}
                                        >
                                            {opportunity.matching_talent?.length > 0 && opportunity.matching_talent.map(matchedOpp => (
                                                <Collapse.Panel
                                                    key={matchedOpp.job_candidate?.id}
                                                    className={(matchedOpp.is_dead || (matchedOpp.job_candidate?.talent_rejected_at || matchedOpp.job_candidate?.talent_withdrew_at)) ? "opacity-60" : undefined}
                                                    header={
                                                        <CollapseTeamsHeader
                                                            onToggle={() => {
                                                                if (matchedOpp.job_candidate?.has_confirmed_scope && matchedOpp?.job_candidate.id && !matchedOpp.is_dead) {
                                                                    return setActiveRow(matchedOpp.job_candidate?.id)
                                                                }
                                                            }}
                                                            isDisabled={!matchedOpp.job_candidate?.has_confirmed_scope || (opportunity.hasWonProject() && opportunity.winningResource()?.id !== matchedOpp.id)}
                                                            isActive={activeRow === matchedOpp.job_candidate?.id}
                                                            teamOpp={matchedOpp}/>
                                                    }
                                                    collapsible={(matchedOpp?.id && !matchedOpp.is_dead) ? "header" : undefined}
                                                >
                                                    <MatchedTeamPanel opportunity={matchedOpp}/>
                                                </Collapse.Panel>
                                            ))}
                                        </Collapse>
                                    </React.Fragment>
                                ) : (
                                    <Collapse
                                        accordion
                                        ghost
                                        activeKey={activeRow}
                                        expandIcon={({isActive, panelKey, ...panelProps}) => {
                                            let talentUserOpp = TB.find(opportunity.matching_talent || [], ['user.id', parseInt(panelKey)]);

                                            if (!talentUserOpp || !talentUserOpp?.id || talentUserOpp.is_dead || !talentUserOpp.is_match) {
                                                return <div className="w-[18px] h-full"/>
                                            }

                                            return (
                                                <RightOutlined
                                                    className="clickable pt-3"
                                                    onClick={async (e) => {
                                                        e.preventDefault()
                                                        if (String(activeRow) === String(panelKey)) {
                                                            return setActiveRow(undefined)
                                                        }
                                                        return setActiveRow(panelKey)
                                                    }}
                                                    rotate={isActive ? 90 : undefined}
                                                    style={{fontSize: 18}}
                                                />
                                            )
                                        }}
                                    >
                                        {opportunity.matching_talent?.length > 0 && opportunity.matching_talent.map(matchedOpp => (
                                            <Collapse.Panel
                                                key={matchedOpp.user?.id}
                                                header={
                                                    <CollapseRolesHeader
                                                        onToggle={() => {
                                                            if (matchedOpp?.id && !matchedOpp.is_dead && matchedOpp.is_match) {
                                                                return setActiveRow(matchedOpp.user?.id)
                                                            }
                                                        }}
                                                        isDisabled={opportunity.hasWonProject() && opportunity.winningResource()?.id !== matchedOpp.id}
                                                        isActive={activeRow === matchedOpp.user?.id}
                                                        talentUserOpp={matchedOpp}/>
                                                }
                                                collapsible={(matchedOpp?.id && !matchedOpp.is_dead && matchedOpp.is_match) ? "header" : undefined}
                                            >
                                                <MatchedTalentPanel opportunity={matchedOpp}/>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const AgencyOppRouter = (props) => {
    const {oppId} = useParams();
    const [queryParams] = useSearchParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const {
        isLoading,
        error,
        opportunity,
        refetch,
    } = useOpportunity()

    const projectPageTitle = (projectName) => {
        if (pathname.includes('review-project-brief/deliverables')) {
            return `Project Scope for ${projectName}`
        }else if (pathname.includes('review-project-brief/team-members')) {
            return `Team Members for ${projectName}`
        }else if (pathname.includes('review-project-brief/client-and-project-overview')) {
            return `Project Overview for ${projectName}`
        }else if (pathname.includes('manage')) {
            return `Manage ${projectName} `
        }
        return projectName
    }

    const checkMiddleware = async () => {
        if (opportunity.project.is_on_hold) {
            await TB.sysAlert('talent.opportunity_disabled_project_on_hold');
            return navigate(TalentPortal.supplierClientProjectsListPath(), {replace: true})
        } else if (opportunity.is_dead) {
            await TB.sysAlert('talent.opportunity_disabled_lost');
            return navigate(opportunity.oppListWithSimilarStatus(), {replace: true})
        }
    }
    const [searchParams, setSearchParams] = useSearchParams();
    useMount(() => {
        if (searchParams.has('firstTime')) {
            TB.alert('confirm', 'Review Project Brief',
                'Review and accept the project brief to pursure your talent resources for this opportunity.');
        }
    })
    useEffect(() => {
        if (!isLoading && opportunity) {
            checkMiddleware();
        }
    }, [isLoading, opportunity])

    if (isLoading) {
        return (
            <div className="talent-portal-page">
                <LoadingBanner message="Loading Project"/>
            </div>
        )
    }

    if (error) {
        return (
            <div className="talent-portal-page">
                <ErrorBanner
                    title={"Something went wrong"}
                    message={"Failed to load project. Please try again"}
                    onRetry={refetch}/>
            </div>
        )
    }


    if (opportunity.project.is_on_hold || opportunity.is_dead) {
        return null;
    }

    return (
        <>
            <Helmet>
                <title>{projectPageTitle(opportunity.project.name)} | Supplier | Wripple</title>
            </Helmet>

            <div className="agency-opp-details talent-portal-page">
                <div className="project-nav py-3">
                    <div className="project-nav-back hidden md:flex">
                        {pathname?.includes('review-project-brief') ? (
                            opportunity.isAccepted() && (
                                <Link to="." replace={true}>
                                    <i className="fa fa-arrow-left mr-2"/>
                                    Back to Matched Talent
                                </Link>
                            )) : (
                            <Link
                                to={TalentPortal.supplierClientProjectsListPath()}>
                                <i className="fa fa-arrow-left mr-2"/>
                                Projects
                            </Link>
                        )}

                    </div>

                    <div className="project-nav-info">
                        <div className="opportunity-title-container">
                            <Link className="opportunity-mobile-back-btn lg:hidden"
                                to={opportunity.oppListWithSimilarStatus()}>
                                <i className="fa fa-arrow-left"/>
                            </Link>
                            <ResponsiveEllipsis
                                text={opportunity.project.name}
                                className="opportunity-nav-title"
                                maxLine={2}
                                ellipsis='...'
                                trimRight
                                basedOn='letters'
                            />

                        </div>
                    </div>

                    <div className="project-nav-type hidden md:flex justify-center">
                        <div>
                            <h5 className="project-type-label">
                                Project Type
                            </h5>
                            <p className="project-type-name">
                                {opportunity.displayType()}
                            </p>
                        </div>
                    </div>
                </div>

                <Routes>
                    <Route index element={!opportunity.isAccepted() ?
                        <Navigate to="review-project-brief" replace={true}/> :
                        <Navigate to="manage" replace={true}/>
                    }/>

                    <Route path="manage/*">
                        <Route index element={<SupplierOppDetails/>}/>
                        <Route path=":candidateId" element={<SupplierManageTeamScopeLayout/>}/>
                    </Route>
                    <Route path="review-project-brief/*" element={<OppReviewBrief/>}/>
                    <Route path="sign-contract/*" element={(opportunity.isPendingContract() && opportunity.hasWonProject() && opportunity.winningResource()) ? <OppSignedContract/> : <Navigate to="." replace={true}/>}/>
                    <Route path="*" element={<Navigate to="." replace={true}/>}/>
                </Routes>


            </div>
        </>
    )

}
export {
    AgencyOppRouter
}